import { EntityTypes } from "../../EntityTypes";
import { IHydraResource } from "../../types";

export interface IEducationalScenarioItemResource extends Omit<IHydraResource, "@context"> {
    "@type": EntityTypes.EDUCATIONAL_SCENARIO_ITEM;
}

export const isEducationalScenarioItemResource = (
    resource: IHydraResource,
): resource is IEducationalScenarioItemResource => {
    return resource["@type"] === EntityTypes.EDUCATIONAL_SCENARIO_ITEM;
};
